export const ADMIN_STRUCTURE_ADD_SECTION = "ADMIN_STRUCTURE_ADD_SECTION"